import React from 'react';
import img6 from '../../assets/logos/img6.png';

import './Modal.css';

const Modal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="profile-modal1-left">
            <img src={img6} alt="img6" className="profile-modal1-img" />
          </div>
          <div className="profile-right">
            <div className="cv-section">
              <h2>Soluciones Legales y Estratégicas</h2>
              <h3>Para negocios e inversores en los Emiratos Árabes Unidos</h3>
              <p>En alianza con otras empresas de Poplavsky Group.</p>
            </div>

            <div className="cv-section">
              <h2>Asesoría Legal Corporativa</h2>
              <ul>
                <li>Constitución y registro de empresas</li>
                <li>Redacción y revisión de contratos</li>
                <li>Cumplimiento normativo</li>
              </ul>
              <p><em>Con Poplavsky International Offices DMCC, firma líder en setup empresarial en EAU.</em></p>
            </div>

            <div className="cv-section">
              <h2>Inversiones y Bienes Raíces</h2>
              <ul>
                <li>Asesoramiento en adquisiciones</li>
                <li>Análisis de riesgos legales</li>
                <li>Gestión de transacciones</li>
              </ul>
              <p><em>En conjunto con Thorne Global UAE, especialistas en real estate.</em></p>
            </div>

            <div className="cv-section">
              <h2>Resolución de Disputas</h2>
              <ul>
                <li>Representación en arbitrajes y litigios</li>
                <li>Negociación de acuerdos</li>
              </ul>
            </div>

            <div className="cv-section">
              <h2>Asistencia en Inmigración y Visas</h2>
              <ul>
                <li>Solicitudes de visas residenciales y laborales</li>
                <li>Asesoramiento en normativas migratorias</li>
              </ul>
              <p><em>Junto a Poplavsky International Offices DMCC.</em></p>
            </div>

            <div className="cv-section">
              <h2>Consultoría Empresarial</h2>
              <ul>
                <li>Planificación estratégica</li>
                <li>Expansión a mercados internacionales</li>
              </ul>
              <p><em>En colaboración con Poplavsky International Offices DMCC.</em></p>
            </div>

            <div className="cv-section">
              <h4>Experiencia en Derecho Internacional</h4>
              <h4>Con más de 25 años de trayectoria, garantizamos respaldo legal y oportunidades de crecimiento en EAU.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;